import { words } from './words';
export function pascalCase(str) {
    return words(str)
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join('');
}
